/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaCheckCircle, FaLock } from 'react-icons/fa';
import { globalContext } from '../Context/GlobalContext';
import styles from './Store.module.css';

// Pantalla que se muestra en /store cuando no hay sesion iniciada
const StoreLogin = () => {
    const [t] = useTranslation('global');
    const { colorTheme } = useContext(globalContext);

    return (
        <div className={styles.root} data-theme={colorTheme === 'dark' ? 'dark' : 'light'}>
            <div className={`${styles.hero} ${styles.heroAcceso}`}>
                <div className={`${styles.wrap} ${styles.heroTop} ${styles.heroTopUna}`}>
                    <div>
                        <div className={styles.kicker}>{t('store.bienvenida-kicker')}</div>
                        <h1>{t('store.acceso-titulo')}</h1>
                        <p>{t('store.acceso-texto')}</p>
                    </div>
                </div>
            </div>

            <div className={styles.accesoCuerpo}>
                <div className={styles.accesoCard}>
                    <div className={styles.accesoIcono} aria-hidden="true">
                        <FaLock />
                    </div>
                    <h2>{t('store.acceso-card-titulo')}</h2>
                    <p>{t('store.acceso-card-texto')}</p>

                    <ul className={styles.accesoBeneficios}>
                        <li><FaCheckCircle aria-hidden="true" /> {t('store.acceso-beneficio-1')}</li>
                        <li><FaCheckCircle aria-hidden="true" /> {t('store.acceso-beneficio-2')}</li>
                        <li><FaCheckCircle aria-hidden="true" /> {t('store.acceso-beneficio-3')}</li>
                    </ul>

                    {/* Tras iniciar sesion, el login vuelve a la pagina anterior (/store) */}
                    <Link to="/login" state={{ from: '/store' }} className={`${styles.btn} ${styles.btnRojo} ${styles.accesoBoton}`}>
                        {t('store.acceso-boton')}
                    </Link>

                    <div className={styles.accesoSeparador} />

                    <p className={styles.accesoRegistro}>
                        {t('store.acceso-sin-usuario')}{' '}
                        <Link to="/registroUsuario">{t('store.acceso-solicitar')}</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default StoreLogin;
